import { withRouter } from "react-router";
import Background from "../components/Background";
import TokensTable from "../components/TokensTable";
import NavTopBar from "../components/NavTopBar";
import PlainContainer from "../components/PlainContainer";
import Footer from "../components/Footer";

const TokensView = ({ history }) => {
  return (
    <>
      <NavTopBar />
      <Background height="45vh" />

      <PlainContainer
        widthInVw={95}
        heightInVh={'auto'}
        customStyles={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          paddingBottom: "0px",
        }}
      >
        <TokensTable />
      </PlainContainer>
      <Footer />
    </>
  );
};

export default withRouter(TokensView);
